module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_iterators.js
 ** module id = 81
 ** module chunks = 0
 **/